import { render } from "./status_popover.vue?vue&type=template&id=3b58cb82"
import script from "./status_popover.js?vue&type=script&lang=js"
export * from "./status_popover.js?vue&type=script&lang=js"

import "./status_popover.vue?vue&type=style&index=0&id=3b58cb82&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__